import { type ReactNode, useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { appScopeChanged } from './appScope'
import { type RootState } from './store'

/** Reset customer/session state before mounting any app content or starting its requests. */
export const AppStateScope = ({
  customer,
  children,
}: {
  customer: string
  children: ReactNode
}) => {
  const scope = useSelector((state: RootState) => state.appScope)
  const { session } = scope
  const dispatch = useDispatch()
  useLayoutEffect(() => {
    dispatch(appScopeChanged({ customer, session }))
  }, [dispatch, customer, session])

  return scope.customer === customer ? children : null
}
